// Bringt geladene Daten auf den aktuellen Schemastand und ergänzt fehlende Felder.
export const SCHEMA_VERSION = 1;

const DEFAULT_EDGE_TYPES = [
  { id: 'manuell', name: 'Ablauf / manuell', farbe: '#748694', dash: '', breite: 1.6 },
  { id: 'muendlich', name: 'Mündlich / E-Mail', farbe: '#9AA7B0', dash: '2 4', breite: 1.8 },
  { id: 'copypaste', name: 'Copy & Paste', farbe: '#C77700', dash: '8 4', breite: 1.8, kennung: 'C&P' },
  { id: 'belegworkflow', name: 'Belegworkflow (Automatik)', farbe: '#009CDE', dash: '', breite: 2.4 },
  { id: 'edi', name: 'EDI', farbe: '#2A5BB0', dash: '10 3 2 3', breite: 2.2, kennung: 'EDI' },
  { id: 'schnittstelle', name: 'Schnittstelle', farbe: '#241C63', dash: '6 3', breite: 2 },
];

export function emptyProject() {
  return migrate({
    schemaVersion: SCHEMA_VERSION,
    meta: { id: 'projekt-' + Math.random().toString(36).slice(2, 8), kunde: 'Neuer Kunde', titel: 'Neue Prozessdokumentation', version: '0.1', stand: new Date().toISOString().slice(0, 10), logoKunde: null, beschreibung: '' },
    lanes: [
      { id: 'kunde', name: 'Kunde', farbe: '#6E7C85' },
      { id: 'vertrieb', name: 'Vertrieb', farbe: '#009CDE' },
      { id: 'produktion', name: 'Produktion', farbe: '#2A5BB0' },
    ],
    systems: [{ id: 'erp', name: 'ERP', kurz: 'ERP', farbe: '#009CDE' }],
    edgeTypes: DEFAULT_EDGE_TYPES,
    processes: [{ id: 'p1', parentId: null, titel: 'Erster Prozess', kurz: '', beschreibung: '', laneIds: ['kunde', 'vertrieb', 'produktion'], order: 0 }],
    nodes: [
      { id: 'p1.start', processId: 'p1', typ: 'start', lane: 'kunde', titel: 'Start' },
      { id: 'p1.schritt', processId: 'p1', typ: 'aktivitaet', lane: 'vertrieb', titel: 'Erster Schritt' },
      { id: 'p1.ende', processId: 'p1', typ: 'ende', lane: 'produktion', titel: 'Ende' },
    ],
    edges: [
      { id: 'e1', processId: 'p1', from: 'p1.start', to: 'p1.schritt', typ: 'manuell', label: '' },
      { id: 'e2', processId: 'p1', from: 'p1.schritt', to: 'p1.ende', typ: 'manuell', label: '' },
    ],
    decisions: [],
  });
}

export function migrate(input) {
  if (!input || typeof input !== 'object') throw new Error('Keine gültigen Prozessdaten.');
  const d = structuredClone(input);
  const v = d.schemaVersion || 1;
  if (v > SCHEMA_VERSION) throw new Error(`Die Datei stammt aus einer neueren Version (Schema ${v}).`);
  d.schemaVersion = SCHEMA_VERSION;
  d.meta = { id: 'projekt', kunde: '', titel: 'Prozesse', ...(d.meta || {}) };
  for (const k of ['lanes', 'systems', 'processes', 'nodes', 'edges', 'decisions']) if (!Array.isArray(d[k])) d[k] = [];
  if (!Array.isArray(d.edgeTypes) || !d.edgeTypes.length) d.edgeTypes = DEFAULT_EDGE_TYPES;
  if (!Array.isArray(d.history)) d.history = [];
  for (const p of d.processes) {
    p.parentId = p.parentId || null;
    p.laneIds = p.laneIds || [];
    p.kurz = p.kurz || '';
    p.beschreibung = p.beschreibung || '';
  }
  for (const n of d.nodes) {
    n.systemIds = n.systemIds || [];
    n.belege = n.belege || [];
    n.quellen = n.quellen || [];
    for (const f of ['beschreibung', 'notizen', 'zielbild', 'verantwortlich', 'input', 'output']) n[f] = n[f] || '';
    n.ausbaustufe2 = !!n.ausbaustufe2;
    n.nurZielbild = !!n.nurZielbild;
    n.status = n.status || null;
    n.subprocessId = n.subprocessId || null;
    n.decisionId = n.decisionId || null;
  }
  for (const e of d.edges) e.label = e.label || '';
  for (const x of d.decisions) {
    x.varianten = (x.varianten || []).map((v) => ({ pro: [], contra: [], beschreibung: '', ...v }));
    x.status = x.status || 'offen';
    x.gewaehlt = x.gewaehlt || null;
    x.quellen = x.quellen || [];
  }
  return d;
}
